module.exports = __webpack_public_path__ + "img/magnifyingglass.d3c9e604.png";